export const FolderIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      className={props.className}
    >
      <path
        d="M16.5 17.3334V28"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83313 19.8653C4.84252 18.8532 4.09523 17.6289 3.64785 16.2852C3.20047 14.9415 3.06474 13.5136 3.25095 12.1097C3.43715 10.7058 3.94041 9.36265 4.72259 8.18203C5.50478 7.00141 6.54538 6.01427 7.76558 5.29539C8.98578 4.5765 10.3536 4.14472 11.7654 4.03276C13.1771 3.92079 14.5959 4.13157 15.9142 4.64913C17.2324 5.1667 18.4156 5.97747 19.3741 7.02004C20.3326 8.0626 21.0413 9.30963 21.4465 10.6667H23.8331C25.1205 10.6665 26.3737 11.0804 27.4078 11.8472C28.4418 12.6141 29.2018 13.6931 29.5755 14.9251C29.9492 16.157 29.9167 17.4764 29.4829 18.6885C29.0491 19.9005 28.237 20.9409 27.1665 21.656"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1665 22.6667L16.4998 17.3334L21.8332 22.6667"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlymouthIcon = (props: { className?: string }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 31 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M30.9804 12.5306C30.9804 6.02932 26.7681 0 18.1666 0H0.0196533V40.9663H6.40294V6.01752H17.1165C21.9777 6.01752 24.3729 8.7667 24.3729 12.7548C24.3729 12.7548 25.423 22.2648 6.40294 22.2648V23.7515C6.40294 23.7515 30.9804 29.4622 30.9804 12.5188V12.5306Z"
        fill="#0C76F3"
      />
    </svg>
  );
};

export const HomeIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M7.18579 13.7807C7.06333 14.0307 6.99993 14.303 7 14.5787V23.1052C7 23.6077 7.21071 24.0897 7.58579 24.445C7.96086 24.8004 8.46957 25 9 25H13.5V19.5C13.5 18.9477 13.9477 18.5 14.5 18.5H17.5C18.0523 18.5 18.5 18.9477 18.5 19.5V25H23C23.5304 25 24.0391 24.8004 24.4142 24.445C24.7893 24.0897 25 23.6077 25 23.1052V14.5787C25.0001 14.303 24.9367 14.0307 24.8142 13.7807C24.6918 13.5307 24.5132 13.309 24.291 13.131L17.291 7.44762C16.93 7.15858 16.4726 7 16 7C15.5274 7 15.07 7.15858 14.709 7.44762L7.709 13.131C7.4868 13.309 7.30824 13.5307 7.18579 13.7807Z"
        stroke="#138AFD"
        strokeWidth="1.12219"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PassportIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect
        x="6"
        y="4"
        width="19.5556"
        height="24.4444"
        rx="2"
        stroke="#138AFD"
        strokeWidth="1.33"
      />
      <path
        d="M15.7754 7.49414C17.5418 7.49421 19.1225 8.28938 20.1797 9.54199L20.3838 9.79883C21.1073 10.7618 21.5361 11.9583 21.5361 13.2559C21.5361 14.4722 21.1597 15.5998 20.5166 16.5293L20.3838 16.7129C19.3321 18.1124 17.6595 19.0165 15.7754 19.0166C14.0086 19.0166 12.4274 18.2217 11.3701 16.9688L11.166 16.7129C10.4426 15.75 10.0137 14.5534 10.0137 13.2559C10.0137 12.0392 10.3908 10.9112 11.0342 9.98145L11.166 9.79883C12.2177 8.39905 13.891 7.49414 15.7754 7.49414Z"
        stroke="#138AFD"
        strokeWidth="0.7"
      />
      <path
        d="M9.66406 21.9443H15.7752M9.66406 24.3888H21.8863"
        stroke="#138AFD"
        strokeWidth="0.7"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const InfoIcon = (props: { className?: string }) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M16.9974 27.2087C22.6353 27.2087 27.2057 22.6382 27.2057 17.0003C27.2057 11.3624 22.6353 6.79199 16.9974 6.79199C11.3595 6.79199 6.78906 11.3624 6.78906 17.0003C6.78906 22.6382 11.3595 27.2087 16.9974 27.2087Z"
        stroke="currentColor"
        strokeWidth="1.35771"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 21.0833V17"
        stroke="currentColor"
        strokeWidth="1.35771"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 12.917H17.01"
        stroke="currentColor"
        strokeWidth="1.35771"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckedBoxIcon = (props: { className?: string }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M11.875 1.875H3.125C2.43125 1.875 1.875 2.4375 1.875 3.125V11.875C1.875 12.5625 2.43125 13.125 3.125 13.125H11.875C12.5688 13.125 13.125 12.5625 13.125 11.875V3.125C13.125 2.4375 12.5688 1.875 11.875 1.875ZM6.25 10.625L3.125 7.5L4.00625 6.61875L6.25 8.85625L10.9937 4.1125L11.875 5L6.25 10.625Z"
        fill="#138AFD"
      />
    </svg>
  );
};

export const QuestionIcon = (props: { className?: string }) => {
  return (
    <svg
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M18.2369 14.9638C20.621 9.51449 26.9806 10.2439 30.0382 12.9203C33.0984 15.5967 33.0984 19.8157 30.0382 22.4921C29.5081 22.9594 28.9154 23.3433 28.2887 23.6462C26.3434 24.5888 24.5026 26.2547 24.5026 28.4167V30.375M48 24.5C48 27.5861 47.3922 30.6419 46.2112 33.4931C45.0302 36.3442 43.2992 38.9348 41.117 41.117C38.9348 43.2992 36.3442 45.0302 33.4931 46.2112C30.6419 47.3922 27.5861 48 24.5 48C21.4139 48 18.3581 47.3922 15.5069 46.2112C12.6558 45.0302 10.0652 43.2992 7.88299 41.117C5.70081 38.9348 3.96982 36.3442 2.78883 33.4931C1.60785 30.6419 1 27.5861 1 24.5C1 18.2674 3.47589 12.2901 7.88299 7.88299C12.2901 3.47589 18.2674 1 24.5 1C30.7326 1 36.7099 3.47589 41.117 7.88299C45.5241 12.2901 48 18.2674 48 24.5ZM24.5 38.2083H24.5209V38.2292H24.5V38.2083Z"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const XIcon = (props: { className?: string }) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect
        x="1"
        y="1"
        width="43"
        height="43"
        rx="21.5"
        stroke="#138AFD"
        strokeWidth="2"
      />
      <path
        d="M27.1693 18.7735L26.2293 17.8335L22.5026 21.5602L18.7759 17.8335L17.8359 18.7735L21.5626 22.5002L17.8359 26.2268L18.7759 27.1668L22.5026 23.4402L26.2293 27.1668L27.1693 26.2268L23.4426 22.5002L27.1693 18.7735Z"
        fill="#138AFD"
      />
    </svg>
  );
};

export const LinkOutIcon = (props: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M4.5 19.5L19.5 4.5M19.5 4.5H8.25M19.5 4.5V15.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ListIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M7.875 6.75H19.875M7.875 12H19.875M7.875 17.25H19.875M3.375 6.75H3.382V6.758H3.375V6.75ZM3.75 6.75C3.75 6.84946 3.71049 6.94484 3.64016 7.01516C3.56984 7.08549 3.47446 7.125 3.375 7.125C3.27554 7.125 3.18016 7.08549 3.10983 7.01516C3.03951 6.94484 3 6.84946 3 6.75C3 6.65054 3.03951 6.55516 3.10983 6.48484C3.18016 6.41451 3.27554 6.375 3.375 6.375C3.47446 6.375 3.56984 6.41451 3.64016 6.48484C3.71049 6.55516 3.75 6.65054 3.75 6.75ZM3.375 12H3.382V12.008H3.375V12ZM3.75 12C3.75 12.0995 3.71049 12.1948 3.64016 12.2652C3.56984 12.3355 3.47446 12.375 3.375 12.375C3.27554 12.375 3.18016 12.3355 3.10983 12.2652C3.03951 12.1948 3 12.0995 3 12C3 11.9005 3.03951 11.8052 3.10983 11.7348C3.18016 11.6645 3.27554 11.625 3.375 11.625C3.47446 11.625 3.56984 11.6645 3.64016 11.7348C3.71049 11.8052 3.75 11.9005 3.75 12ZM3.375 17.25H3.382V17.258H3.375V17.25ZM3.75 17.25C3.75 17.3495 3.71049 17.4448 3.64016 17.5152C3.56984 17.5855 3.47446 17.625 3.375 17.625C3.27554 17.625 3.18016 17.5855 3.10983 17.5152C3.03951 17.4448 3 17.3495 3 17.25C3 17.1505 3.03951 17.0552 3.10983 16.9848C3.18016 16.9145 3.27554 16.875 3.375 16.875C3.47446 16.875 3.56984 16.9145 3.64016 16.9848C3.71049 17.0552 3.75 17.1505 3.75 17.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProfileIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M11.6666 1.66699V5.00033C11.6666 5.44235 11.8422 5.86628 12.1548 6.17884C12.4673 6.4914 12.8913 6.66699 13.3333 6.66699H16.6666"
        stroke="#292929"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 15C12.5 14.337 12.2366 13.7011 11.7678 13.2322C11.2989 12.7634 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.7634 8.23223 13.2322C7.76339 13.7011 7.5 14.337 7.5 15"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 1.66699H5.00004C4.55801 1.66699 4.13409 1.84259 3.82153 2.15515C3.50897 2.46771 3.33337 2.89163 3.33337 3.33366V16.667C3.33337 17.109 3.50897 17.5329 3.82153 17.8455C4.13409 18.1581 4.55801 18.3337 5.00004 18.3337H15C15.4421 18.3337 15.866 18.1581 16.1786 17.8455C16.4911 17.5329 16.6667 17.109 16.6667 16.667V5.83366L12.5 1.66699Z"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5003C10.9205 12.5003 11.6667 11.7541 11.6667 10.8337C11.6667 9.91318 10.9205 9.16699 10 9.16699C9.07957 9.16699 8.33337 9.91318 8.33337 10.8337C8.33337 11.7541 9.07957 12.5003 10 12.5003Z"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M12.5 8.75C12.5 9.41304 12.2366 10.0489 11.7678 10.5178C11.2989 10.9866 10.663 11.25 10 11.25C9.33696 11.25 8.70107 10.9866 8.23223 10.5178C7.76339 10.0489 7.5 9.41304 7.5 8.75C7.5 8.08696 7.76339 7.45107 8.23223 6.98223C8.70107 6.51339 9.33696 6.25 10 6.25C10.663 6.25 11.2989 6.51339 11.7678 6.98223C12.2366 7.45107 12.5 8.08696 12.5 8.75Z"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 8.75C16.25 14.7017 10 18.125 10 18.125C10 18.125 3.75 14.7017 3.75 8.75C3.75 7.0924 4.40848 5.50268 5.58058 4.33058C6.75268 3.15848 8.3424 2.5 10 2.5C11.6576 2.5 13.2473 3.15848 14.4194 4.33058C15.5915 5.50268 16.25 7.0924 16.25 8.75Z"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BriefcaseIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M10 10H10.0083"
        stroke="#292929"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 5.00033V3.33366C13.3333 2.89163 13.1577 2.46771 12.8451 2.15515C12.5326 1.84259 12.1087 1.66699 11.6666 1.66699H8.33329C7.89127 1.66699 7.46734 1.84259 7.15478 2.15515C6.84222 2.46771 6.66663 2.89163 6.66663 3.33366V5.00033"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 10.833C15.8606 12.4655 12.9629 13.3358 9.99996 13.3358C7.037 13.3358 4.1393 12.4655 1.66663 10.833"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6666 5H3.33329C2.41282 5 1.66663 5.74619 1.66663 6.66667V15C1.66663 15.9205 2.41282 16.6667 3.33329 16.6667H16.6666C17.5871 16.6667 18.3333 15.9205 18.3333 15V6.66667C18.3333 5.74619 17.5871 5 16.6666 5Z"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SignatureIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M15.625 13.1252L14.2775 11.9577C14.233 11.9155 14.177 11.8873 14.1165 11.8767C14.0561 11.8661 13.9938 11.8735 13.9376 11.898C13.8813 11.9226 13.8335 11.9631 13.8002 12.0146C13.7668 12.0662 13.7494 12.1264 13.75 12.1877V12.5002C13.75 12.666 13.6842 12.825 13.5669 12.9422C13.4497 13.0594 13.2908 13.1252 13.125 13.1252H11.875C11.7092 13.1252 11.5503 13.0594 11.4331 12.9422C11.3158 12.825 11.25 12.666 11.25 12.5002C11.25 10.9096 8.75562 10.019 5.9375 10.0002C5.5231 10.0002 5.12567 10.1648 4.83265 10.4579C4.53962 10.7509 4.375 11.1483 4.375 11.5627C4.375 11.9771 4.53962 12.3746 4.83265 12.6676C5.12567 12.9606 5.5231 13.1252 5.9375 13.1252C8.53312 13.1252 8.90313 6.06585 9.505 4.68772C9.60667 4.45509 9.7635 4.25074 9.96191 4.09236C10.1603 3.93397 10.3943 3.82631 10.6437 3.7787C10.8931 3.73109 11.1503 3.74496 11.3931 3.81911C11.6359 3.89327 11.857 4.02547 12.0372 4.20427C12.2174 4.38308 12.3514 4.60311 12.4274 4.84533C12.5035 5.08754 12.5194 5.34464 12.4738 5.59438C12.4281 5.84412 12.3223 6.07898 12.1655 6.27863C12.0087 6.47829 11.8056 6.63672 11.5737 6.74022"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 15.625H15.625"
        stroke="#292929"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileDocumentIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M7.5 10H10.625M7.5 12.5H10.625M7.5 15H10.625M13.125 15.625H15C15.4973 15.625 15.9742 15.4275 16.3258 15.0758C16.6775 14.7242 16.875 14.2473 16.875 13.75V5.09C16.875 4.14417 16.1708 3.34167 15.2283 3.26333C14.9167 3.23749 14.6047 3.21526 14.2925 3.19667M14.2925 3.19667C14.3478 3.3759 14.3751 3.56243 14.375 3.75C14.375 3.91576 14.3092 4.07473 14.1919 4.19194C14.0747 4.30915 13.9158 4.375 13.75 4.375H10C9.655 4.375 9.375 4.095 9.375 3.75C9.375 3.5575 9.40417 3.37167 9.45833 3.19667M14.2925 3.19667C14.0567 2.43167 13.3433 1.875 12.5 1.875H11.25C10.8494 1.87509 10.4593 2.00345 10.1369 2.24128C9.81448 2.47911 9.57669 2.81392 9.45833 3.19667M9.45833 3.19667C9.145 3.21583 8.83333 3.23833 8.52167 3.26333C7.57917 3.34167 6.875 4.14417 6.875 5.09V6.875M6.875 6.875H4.0625C3.545 6.875 3.125 7.295 3.125 7.8125V17.1875C3.125 17.705 3.545 18.125 4.0625 18.125H12.1875C12.705 18.125 13.125 17.705 13.125 17.1875V7.8125C13.125 7.295 12.705 6.875 12.1875 6.875H6.875ZM5.625 10H5.63167V10.0067H5.625V10ZM5.625 12.5H5.63167V12.5067H5.625V12.5ZM5.625 15H5.63167V15.0067H5.625V15Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewspaperIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M5 16.25H15C15.3315 16.25 15.6495 16.1183 15.8839 15.8839C16.1183 15.6495 16.25 15.3315 16.25 15V5C16.25 4.66848 16.1183 4.35054 15.8839 4.11612C15.6495 3.8817 15.3315 3.75 15 3.75H7.5C7.16848 3.75 6.85054 3.8817 6.61612 4.11612C6.3817 4.35054 6.25 4.66848 6.25 5V15C6.25 15.3315 6.1183 15.6495 5.88388 15.8839C5.64946 16.1183 5.33152 16.25 5 16.25ZM5 16.25C4.66848 16.25 4.35054 16.1183 4.11612 15.8839C3.8817 15.6495 3.75 15.3315 3.75 15V9.375C3.75 8.6875 4.3125 8.125 5 8.125H6.25"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 11.25H8.75"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.875 13.75H8.75"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 6.25H13.75V8.75H8.75V6.25Z"
        stroke="#292929"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Chevron Icon Components
export const ChevronUpIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.175 13.0876L10 9.27098L13.825 13.0876L15 11.9126L10 6.91265L5 11.9126L6.175 13.0876Z"
      fill="#B3B3B3"
    />
  </svg>
);

export const ChevronDownIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.825 6.91235L10 10.729L6.175 6.91235L5 8.08735L10 13.0874L15 8.08735L13.825 6.91235Z"
      fill="#B3B3B3"
    />
  </svg>
);

export const BeneficiaryIcon = (props: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M16.6667 17.5C16.6667 15.1988 13.6819 13.3333 10 13.3333C6.31814 13.3333 3.33337 15.1988 3.33337 17.5M10 10.8333C7.69885 10.8333 5.83337 8.96785 5.83337 6.66667C5.83337 4.36548 7.69885 2.5 10 2.5C12.3012 2.5 14.1667 4.36548 14.1667 6.66667C14.1667 8.96785 12.3012 10.8333 10 10.8333Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TeamIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M22.6667 27V24.3333C22.6667 22.9188 22.1048 21.5623 21.1046 20.5621C20.1044 19.5619 18.7478 19 17.3333 19H6.66667C5.25218 19 3.89563 19.5619 2.89543 20.5621C1.89524 21.5623 1.33333 22.9188 1.33333 24.3333V27"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.6667C14.9455 13.6667 17.3333 11.2789 17.3333 8.33333C17.3333 5.38781 14.9455 3 12 3C9.05448 3 6.66667 5.38781 6.66667 8.33333C6.66667 11.2789 9.05448 13.6667 12 13.6667Z"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6667 27V24.3333C30.6651 23.1516 30.2471 22.0079 29.4823 21.0851C28.7175 20.1624 27.6567 19.5145 26.4667 19.2467"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1333 3.24667C22.3271 3.51261 23.392 4.16088 24.1597 5.08533C24.9274 6.00978 25.3465 7.15634 25.3465 8.34167C25.3465 9.527 24.9274 10.6736 24.1597 11.598C23.392 12.5225 22.3271 13.1707 21.1333 13.4367"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotFoundIcon = (props: { className?: string }) => {
  return (
    <svg
      width="64"
      height="63"
      viewBox="0 0 64 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M32 23.625V33.4687M7.57958 42.3307C5.30633 46.2682 8.14921 51.1875 12.6931 51.1875H51.3068C55.8481 51.1875 58.691 46.2682 56.4203 42.3307L37.1161 8.86725C34.8428 4.92975 29.1571 4.92975 26.8838 8.86725L7.57958 42.3307ZM32 41.3437H32.0183V41.3647H32V41.3437Z"
        stroke="#138AFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ApplicantIcon = (props: { className?: string }) => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M10.125 4C10.125 4.8288 9.79578 5.62366 9.20973 6.20971C8.62368 6.79576 7.82882 7.125 7.00002 7.125C6.17122 7.125 5.37636 6.79576 4.79031 6.20971C4.20426 5.62366 3.87502 4.8288 3.87502 4C3.87502 3.1712 4.20426 2.37634 4.79031 1.79029C5.37636 1.20424 6.17122 0.875 7.00002 0.875C7.82882 0.875 8.62368 1.20424 9.20973 1.79029C9.79578 2.37634 10.125 3.1712 10.125 4ZM0.750854 15.765C0.777633 14.1253 1.4478 12.5618 2.61684 11.4117C3.78587 10.2616 5.36009 9.61706 7.00002 9.61706C8.63995 9.61706 10.2142 10.2616 11.3832 11.4117C12.5522 12.5618 13.2224 14.1253 13.2492 15.765C11.2887 16.664 9.15681 17.1279 7.00002 17.125C4.77002 17.125 2.65335 16.6383 0.750854 15.765Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CasesIcon = (props: { className?: string }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M0.75 9H17.25M0.75 12.75H17.25M0.75 16.5H17.25M2.625 1.5H15.375C15.8723 1.5 16.3492 1.69754 16.7008 2.04917C17.0525 2.40081 17.25 2.87772 17.25 3.375C17.25 3.87228 17.0525 4.34919 16.7008 4.70083C16.3492 5.05246 15.8723 5.25 15.375 5.25H2.625C2.12772 5.25 1.65081 5.05246 1.29917 4.70083C0.947544 4.34919 0.75 3.87228 0.75 3.375C0.75 2.87772 0.947544 2.40081 1.29917 2.04917C1.65081 1.69754 2.12772 1.5 2.625 1.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HandIcon = (props: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M10.05 4.575C10.05 4.36817 10.0093 4.16336 9.93011 3.97227C9.85096 3.78119 9.73495 3.60756 9.58869 3.46131C9.44244 3.31505 9.26881 3.19904 9.07773 3.11989C8.88664 3.04074 8.68183 3 8.475 3C8.26817 3 8.06336 3.04074 7.87227 3.11989C7.68119 3.19904 7.50756 3.31505 7.36131 3.46131C7.21505 3.60756 7.09904 3.78119 7.01989 3.97227C6.94074 4.16336 6.9 4.36817 6.9 4.575V7.575M10.05 4.575V3.075C10.05 2.65728 10.2159 2.25668 10.5113 1.96131C10.8067 1.66594 11.2073 1.5 11.625 1.5C12.0427 1.5 12.4433 1.66594 12.7387 1.96131C13.0341 2.25668 13.2 2.65728 13.2 3.075V4.575M10.05 4.575L10.125 10.5M6.9 7.575C6.9 7.15728 6.73406 6.75668 6.43869 6.46131C6.14332 6.16594 5.74272 6 5.325 6C4.90728 6 4.50668 6.16594 4.21131 6.46131C3.91594 6.75668 3.75 7.15728 3.75 7.575V15.75C3.75 17.5402 4.46116 19.2571 5.72703 20.523C6.9929 21.7888 8.70979 22.5 10.5 22.5H12.518C13.9103 22.4998 15.2456 21.9466 16.23 20.962L17.962 19.23C18.9466 18.2456 19.4998 16.9103 19.5 15.518L19.503 13.494C19.504 13.317 19.5752 13.1476 19.701 13.023C19.8473 12.8767 19.9633 12.703 20.0425 12.5119C20.1217 12.3208 20.1624 12.1159 20.1624 11.909C20.1624 11.7021 20.1217 11.4972 20.0425 11.3061C19.9633 11.115 19.8473 10.9413 19.701 10.795C19.5547 10.6487 19.381 10.5327 19.1899 10.4535C18.9988 10.3743 18.7939 10.3336 18.587 10.3336C18.3801 10.3336 18.1752 10.3743 17.9841 10.4535C17.793 10.5327 17.6193 10.6487 17.473 10.795C16.7595 11.5076 16.3568 12.4736 16.353 13.482M6.9 7.575V12M13.2 4.575V11.25M13.2 4.575C13.2 4.15728 13.3659 3.75668 13.6613 3.46131C13.9567 3.16594 14.3573 3 14.775 3C15.1927 3 15.5933 3.16594 15.8887 3.46131C16.1841 3.75668 16.35 4.15728 16.35 4.575V15M16.35 15C15.7593 14.9997 15.1744 15.116 14.6287 15.3421C14.083 15.5683 13.5873 15.8999 13.17 16.318M16.35 15H16.352"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CaseTeamIcon = (props: { className?: string }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M15.558 13.146C16.0258 12.8265 16.5745 12.6461 17.1406 12.6254C17.7067 12.6048 18.267 12.7449 18.7568 13.0294C19.2466 13.314 19.6459 13.7314 19.9083 14.2334C20.1708 14.7354 20.2858 15.3014 20.24 15.866C19.0402 16.2853 17.7658 16.4485 16.499 16.345C16.4951 15.2116 16.1687 14.1018 15.558 13.147C15.0159 12.2968 14.2681 11.597 13.3838 11.1125C12.4996 10.628 11.5073 10.3743 10.499 10.375C9.49085 10.3745 8.49884 10.6282 7.61474 11.1127C6.73064 11.5973 5.98301 12.2969 5.44101 13.147M16.498 16.344L16.499 16.375C16.499 16.6 16.487 16.822 16.462 17.041C14.6474 18.0821 12.5911 18.6283 10.499 18.625C8.32901 18.625 6.29201 18.049 4.53601 17.041C4.5103 16.8096 4.49795 16.5769 4.49901 16.344M4.49901 16.344C3.23264 16.4513 1.95892 16.2887 0.760008 15.867C0.714359 15.3026 0.829403 14.7367 1.09184 14.2349C1.35427 13.7331 1.75338 13.3158 2.24301 13.0313C2.73264 12.7468 3.2928 12.6067 3.85873 12.6271C4.42465 12.6476 4.97322 12.8278 5.44101 13.147M4.49901 16.344C4.5026 15.2107 4.83063 14.1019 5.44101 13.147M13.499 4.375C13.499 5.17065 13.1829 5.93371 12.6203 6.49632C12.0577 7.05893 11.2947 7.375 10.499 7.375C9.70336 7.375 8.9403 7.05893 8.37769 6.49632C7.81508 5.93371 7.49901 5.17065 7.49901 4.375C7.49901 3.57935 7.81508 2.81629 8.37769 2.25368C8.9403 1.69107 9.70336 1.375 10.499 1.375C11.2947 1.375 12.0577 1.69107 12.6203 2.25368C13.1829 2.81629 13.499 3.57935 13.499 4.375ZM19.499 7.375C19.499 7.67047 19.4408 7.96306 19.3277 8.23604C19.2147 8.50902 19.0489 8.75706 18.84 8.96599C18.6311 9.17492 18.383 9.34066 18.11 9.45373C17.8371 9.5668 17.5445 9.625 17.249 9.625C16.9535 9.625 16.661 9.5668 16.388 9.45373C16.115 9.34066 15.8669 9.17492 15.658 8.96599C15.4491 8.75706 15.2834 8.50902 15.1703 8.23604C15.0572 7.96306 14.999 7.67047 14.999 7.375C14.999 6.77826 15.2361 6.20597 15.658 5.78401C16.08 5.36205 16.6523 5.125 17.249 5.125C17.8457 5.125 18.418 5.36205 18.84 5.78401C19.262 6.20597 19.499 6.77826 19.499 7.375ZM5.99901 7.375C5.99901 7.67047 5.94081 7.96306 5.82774 8.23604C5.71466 8.50902 5.54893 8.75706 5.34 8.96599C5.13107 9.17492 4.88303 9.34066 4.61005 9.45373C4.33706 9.5668 4.04448 9.625 3.74901 9.625C3.45353 9.625 3.16095 9.5668 2.88797 9.45373C2.61499 9.34066 2.36695 9.17492 2.15802 8.96599C1.94909 8.75706 1.78335 8.50902 1.67028 8.23604C1.55721 7.96306 1.49901 7.67047 1.49901 7.375C1.49901 6.77826 1.73606 6.20597 2.15802 5.78401C2.57998 5.36205 3.15227 5.125 3.74901 5.125C4.34575 5.125 4.91804 5.36205 5.34 5.78401C5.76196 6.20597 5.99901 6.77826 5.99901 7.375Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileTextIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M19 6H10C9.46957 6 8.96086 6.21071 8.58579 6.58579C8.21071 6.96086 8 7.46957 8 8V24C8 24.5304 8.21071 25.0391 8.58579 25.4142C8.96086 25.7893 9.46957 26 10 26H22C22.5304 26 23.0391 25.7893 23.4142 25.4142C23.7893 25.0391 24 24.5304 24 24V11L19 6Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6V10C18 10.5304 18.2107 11.0391 18.5858 11.4142C18.9609 11.7893 19.4696 12 20 12H24"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13H12"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 17H12"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 21H12"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MailIcon = (props: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M24 8H8C6.89543 8 6 8.89543 6 10V22C6 23.1046 6.89543 24 8 24H24C25.1046 24 26 23.1046 26 22V10C26 8.89543 25.1046 8 24 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 11L17.03 16.7C16.7213 16.8934 16.3643 16.996 16 16.996C15.6357 16.996 15.2787 16.8934 14.97 16.7L6 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CheckCircleIcon = (props: { className?: string }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M9 14L12 17L17 10M25 13C25 14.5759 24.6896 16.1363 24.0866 17.5922C23.4835 19.0481 22.5996 20.371 21.4853 21.4853C20.371 22.5996 19.0481 23.4835 17.5922 24.0866C16.1363 24.6896 14.5759 25 13 25C11.4241 25 9.86371 24.6896 8.4078 24.0866C6.95189 23.4835 5.62902 22.5996 4.51472 21.4853C3.40042 20.371 2.5165 19.0481 1.91345 17.5922C1.31039 16.1363 1 14.5759 1 13C1 9.8174 2.26428 6.76516 4.51472 4.51472C6.76516 2.26428 9.8174 1 13 1C16.1826 1 19.2348 2.26428 21.4853 4.51472C23.7357 6.76516 25 9.8174 25 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmptyCircleIcon = (props: { className?: string }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect
        x="0.75"
        y="0.75"
        width="24.5"
        height="24.5"
        rx="12.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const SortAscIcon = (props: { className?: string }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.75 12.375L10 8.625L6.25 12.375"
      stroke="#292929"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortDescIcon = (props: { className?: string }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.25 8.625L10 12.375L13.75 8.625"
      stroke="#292929"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortBothIcon = (props: { className?: string }) => (
  <svg
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.00001 2.40083L4.84918 4.25L5.67168 3.4275L3.00001 0.75L0.32251 3.4275L1.15084 4.25L3.00001 2.40083ZM3.00001 9.59917L1.15084 7.75L0.328343 8.5725L3.00001 11.25L5.67751 8.5725L4.84918 7.75L3.00001 9.59917Z"
      fill="currentColor"
    />
  </svg>
);

export const ExpandIcon = (props: { className?: string }) => (
  <svg
    className="w-4 h-4 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export const CollapseIcon = (props: { className?: string }) => (
  <svg
    className="w-4 h-4 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export const SearchIcon = (props: { className?: string }) => (
  <svg
    className="absolute left-4 w-5 h-5 text-foreground"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export const ChevronDownSmallIcon = (props: { className?: string }) => (
  <svg
    className="w-4 h-4 text-muted"
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export const ExternalLinkIcon = (props: { className?: string }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.33333 3.5V4.83333H10.7267L3 12.56L3.94 13.5L11.6667 5.77333V10.1667H13V3.5H6.33333Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusIcon = (props: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path d="M8 3V13M3 8H13" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
